/**
 * A small util that is used to increment or decrement a number until it reaches
 * the max value or -1. When that happens, it will loop around to 0 or the max
 * value respectively. This does not work for different increment numbers or any
 * values below 0 for now.
 *
 * @internal
 * @param options - {@link LoopOptions}
 * @remarks \@since 2.7.0 The `min` option was added and the arguments changed to an
 * object
 */
export function loop(_a) {
    var value = _a.value, _b = _a.min, min = _b === void 0 ? 0 : _b, max = _a.max, increment = _a.increment, _c = _a.minmax, minmax = _c === void 0 ? false : _c;
    var next = value + (increment ? 1 : -1);
    if (minmax) {
        next = Math.min(max, Math.max(min, next));
    }
    else if (next > max) {
        next = min;
    }
    else if (next < min) {
        next = max;
    }
    return next;
}
//# sourceMappingURL=loop.js.map